var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reaction && _vm.reaction.emoji)?_c('div',{class:['reaction-emoji-container', { 'is-reverse': _vm.isReverse }]},[_vm._v(" "+_vm._s(_vm.reaction.emoji)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }